// extracted by mini-css-extract-plugin
export default {"items":"rBj0nXAsEVjk8aKRE3an","section":"_UUd2AKzKWO2_IfluLXD"};